//react
import { useEffect, useState } from "react";

//components
import { HUForm } from "../../Components/HUForm";
import {
  Container,
  CardInfs,
  ContainerReserves,
  ContainerOccupied,
  ContainerMaintenance,
  ContainerAvailable,
  Reserves,
  Status,
  Price,
  ContainerReservesHeader,
  ProductsAndServicesContainer,
  ContainerFather,
  Title,
  ProdsAndServicesHeader,
} from "./styles";
import { ListCardBox } from "../../Components/ListCardBox";
import Button from "../../Components/Button";
import ModalElement from "../../Components/Modal";
import { CardProductOrServiceHU } from "../../Components/CardProductOrServiceHU";
import AddProds from "../../Components/AddProdsToHU";
import maintenance from "../../Assets/maintenance.svg";

//router-dom
import { useParams } from "react-router-dom";

//axios
import { useHabUnits } from "../../Providers/HabUnit";

//utils
import { formatter } from "../../Utils";

//interfaces
import { IHU, IProductHU, IReserve, IServiceHU } from "../../Interfaces";
import { GearButton } from "../../Components/GearButton";
import AddService from "../../Components/AddServicesToHU";
import FormReserve from "../../Components/FormReserve";
import FormCheckIn from "../../Components/FormCheckIn";
import CardReserve from "../../Components/CardReserve";
import Footer from "../../Components/Footer";

const SpecificHU = () => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const { id } = useParams<{ id: string }>();
  const { AdmHUList, getTotal, checkOut, listHUs } = useHabUnits();

  const [currentHU, setCurrentHU] = useState<IHU>();
  const [productModalIsOpen, setProductModalIsOpen] = useState<boolean>(false);
  const [serviceModalIsOpen, setServiceModalIsOpen] = useState<boolean>(false);
  const [productsState, setProductsState] = useState<IProductHU[]>();
  const [servicesState, setServicesState] = useState<IServiceHU[]>();
  const [reservesState, setReservesState] = useState<IReserve[]>();
  const [reserveModalIsopen, setReserveModalIsopen] = useState<boolean>(false);
  const [checkInModalIsOpen, setCheckInModalIsOpen] = useState<boolean>(false);
  const [total, setTotal] = useState<number>(0);

  const handleReserveModal = () => {
    setReserveModalIsopen(!reserveModalIsopen);
  };

  const handleProductModal = () => {
    setProductModalIsOpen(!productModalIsOpen);
  };

  const handleServiceModal = () => {
    setServiceModalIsOpen(!serviceModalIsOpen);
  };

  const handleCheckInModal = () => {
    setCheckInModalIsOpen(!checkInModalIsOpen);
  };
  useEffect(() => {
    listHUs();
  }, []);

  useEffect(() => {
    // listHUs(userID);
    setCurrentHU(AdmHUList.find((el) => el.id === Number(id)));
    setProductsState(currentHU?.products);
    setServicesState(currentHU?.services);
    setReservesState(currentHU?.reserves);
    if (currentHU !== undefined) {
      setTotal(getTotal(currentHU));
    }
  }, [currentHU, AdmHUList, id, getTotal]);

  if (currentHU !== undefined) {
    const { title, price, guests, state, type } = currentHU;
    return (
      <Container>
        {state === "occupied" && (
          <ContainerOccupied>
            <Status className="occupied">Ocupado</Status>
            <CardInfs>
              <GearButton
                showModal={() => {
                  setShowModal(true);
                }}
              />
              <Title>{type}</Title>
              <Title>{title}</Title>
              <ul>
                <h2>Lista de hospedes</h2>
                {guests &&
                  guests.map((guest, i) => <li key={i}>{guest.name}</li>)}
              </ul>
            </CardInfs>
            <ContainerFather>
              <ContainerReserves>
                <Reserves>Reservas</Reserves>
                <Button className="addButton" onClick={handleReserveModal}>
                  Nova reserva
                </Button>
                <ListCardBox style={{}} className={"listCardBoxReserves"}>
                  <ContainerReservesHeader></ContainerReservesHeader>
                  <ModalElement
                    isOpen={reserveModalIsopen}
                    closeModal={handleReserveModal}
                  >
                    <FormReserve
                      HU={currentHU}
                      closeModal={handleReserveModal}
                    />
                  </ModalElement>
                  {reservesState?.map((el, index) => (
                    <CardReserve key={index} reserve={el} HU={currentHU} />
                  ))}
                </ListCardBox>
              </ContainerReserves>
            </ContainerFather>

            <ContainerFather>
              <ProductsAndServicesContainer>
                <ProdsAndServicesHeader>
                  <Reserves>Produtos</Reserves>
                  <Button onClick={handleProductModal} className="addButton">
                    +
                  </Button>
                </ProdsAndServicesHeader>
                <ListCardBox
                  style={{ maxHeight: "300px", margin: "0", width: "100%" }}
                >
                  <div className="products">
                    <ul>
                      {productsState?.map((product, index) => (
                        <li key={index}>
                          <CardProductOrServiceHU
                            data={product}
                            HU={currentHU}
                            type="product"
                          />
                        </li>
                      ))}
                    </ul>
                    <ModalElement
                      closeModal={handleProductModal}
                      isOpen={productModalIsOpen}
                    >
                      <AddProds
                        HU={currentHU}
                        prodsState={productsState}
                        updateProdsState={setProductsState}
                        closeModal={handleProductModal}
                      />
                    </ModalElement>
                  </div>
                </ListCardBox>
              </ProductsAndServicesContainer>
              <ProductsAndServicesContainer>
                <ProdsAndServicesHeader>
                  <Reserves>Serviços</Reserves>
                  <Button onClick={handleServiceModal} className="addButton">
                    +
                  </Button>

                </ProdsAndServicesHeader>
                <ListCardBox
                  style={{
                    maxHeight: "300px",
                    margin: "0",
                    width: "100%",
                    marginTop: "1rem",
                  }}
                >
                  <div className="services">
                    <ul>
                      {servicesState?.map((service, index) => (
                        <li key={index}>
                          <CardProductOrServiceHU
                            data={service}
                            HU={currentHU}
                            type="service"
                          />
                        </li>
                      ))}
                    </ul>
                    <ModalElement
                      closeModal={handleServiceModal}
                      isOpen={serviceModalIsOpen}
                    >
                      <AddService
                        HU={currentHU}
                        servicesState={servicesState}
                        updateServState={setServicesState}
                        closeModal={handleServiceModal}
                      />
                    </ModalElement>
                  </div>
                </ListCardBox>
              </ProductsAndServicesContainer>
            </ContainerFather>

            <div className="endPage">
              <div className="total">Total: {formatter.format(total)}</div>
              <Button
                className="checkout"
                type="button"
                onClick={() => checkOut(currentHU)}
                small
              >
                Checkout
              </Button>
            </div>
            <ModalElement
              closeModal={() => setShowModal(false)}
              isOpen={showModal}
            >
              <HUForm HU={currentHU} closeModal={() => setShowModal(false)} />
            </ModalElement>
          </ContainerOccupied>
        )}
        {state === "maintenance" && (
          <ContainerMaintenance className="Contentmaintenance">
            <Status className="maintenance">Em manutenção</Status>
            <div>
              <img
                src={maintenance}
                alt="maintenance"
                className="maintenanceImage"
              />
            </div>
          </ContainerMaintenance>
        )}
        {state === "available" && (
          <ContainerAvailable className="contentAvailable">
            <Status className="avaliable">Disponível</Status>

            <Button
              className="checkin"
              id="checkin"
              type="button"
              onClick={handleCheckInModal}
            >
              Checkin
            </Button>
            <Button className="addButton" onClick={handleReserveModal}>
              Nova reserva
            </Button>
            <ModalElement
              isOpen={checkInModalIsOpen}
              closeModal={handleCheckInModal}
            >
              <FormCheckIn HU={currentHU} closeModal={handleCheckInModal} />
            </ModalElement>
            <ContainerReserves style={{ margin: "0 auto" }}>
              <Reserves>Reservas</Reserves>
              <ListCardBox
                style={{ maxHeight: "200px", margin: "0 auto" }}
                className={"listCardBoxReserves"}
              >
                <ModalElement
                  isOpen={reserveModalIsopen}
                  closeModal={handleReserveModal}
                >
                  <FormReserve HU={currentHU} closeModal={handleReserveModal} />
                </ModalElement>
                {reservesState?.map((el, index) => (
                  <CardReserve key={index} reserve={el} HU={currentHU} />
                ))}
              </ListCardBox>
            </ContainerReserves>
            <Price>Preço da diária: {formatter.format(price)}</Price>
          </ContainerAvailable>
        )}
        <Footer />
      </Container>
    );
  } else {
    return <div />;
  }
};

export default SpecificHU;
